// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const CustomerOrderProfitabilityPlanLineScenarioTypeValues = ["BUDGET", "FORECAST"] as const;

export type CustomerOrderProfitabilityPlanLineScenarioType =
	(typeof CustomerOrderProfitabilityPlanLineScenarioTypeValues)[number];

export const getCustomerOrderProfitabilityPlanLineScenarioTypeLabels = () => ({
	BUDGET: t("budget"),
	FORECAST: t("forecast"),
});

export const getCustomerOrderProfitabilityPlanLineScenarioTypeLabel = (
	value: CustomerOrderProfitabilityPlanLineScenarioType,
): string => {
	return getCustomerOrderProfitabilityPlanLineScenarioTypeLabels()[value];
};
